import ElectionMenu from './ElectionMenu';
export default ElectionMenu;
